import {
  HomeOutlined,
  LockOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import { Menu, type MenuProps } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';
import { SiteRole } from 'types/Roles';
import { arrayMapFilter } from 'utils/Array';

import AdHubLogo from '../AdHubLogo/AdHubLogo';
import Spacer from '../Spacer/Spacer';
import UserButton from '../UserButton/UserButton';
import { LogoContainer, Nav } from './NavSidebar.styles';

type MenuItem = Required<MenuProps>['items'][number];

export interface NavSidebarProps {
  className?: string;
}

function NavSidebar(props: NavSidebarProps) {
  const menuSeed = [
    {
      icon: <HomeOutlined />,
      label: 'Dashboard',
      // Note: key must match the route path that this item represents,
      // because the current route is used to determine which menu item is
      // highlighted.
      key: '/dashboard',
      present: true,
      enabled: store.user.data.activated,
      onClick: () => store.router.goTo(store.routes.dashboard),
    },
    {
      icon: <SolutionOutlined />,
      label: 'Clients',
      key: '/clients',
      present: true,
      enabled: store.user.data.activated,
      onClick: () => store.router.goTo(store.routes.clients),
    },
    {
      icon: <LockOutlined />,
      label: 'Admin',
      key: '/admin',
      present: store.user.role === SiteRole.ADMIN,
      enabled: true,
      onClick: () => store.router.goTo(store.routes.admin),
    },
  ];

  const menuItems: MenuItem[] = arrayMapFilter(menuSeed, (mi) => {
    return mi.present
      ? {
          icon: mi.icon,
          key: mi.key,
          label: mi.label,
          title: mi.label,
          disabled: !mi.enabled,
          onClick: mi.onClick,
        }
      : undefined;
  });

  return (
    <Nav
      className={props.className}
      collapsed={store.ui.collapsed}
      collapsible
      trigger={null}
    >
      <LogoContainer className={store.ui.collapsed ? 'collapsed logo' : 'logo'}>
        <AdHubLogo collapsed={store.ui.collapsed} />
      </LogoContainer>

      <Menu
        theme="dark"
        mode="inline"
        selectable={false}
        selectedKeys={[store.router.currentPath]}
        items={menuItems}
      />

      <Spacer />
      <UserButton />
    </Nav>
  );
}

export default observer(NavSidebar);
